module.exports = fox._r("fonts/icons-lib/icons-lib.ttf?n7cb91", __webpack_public_path__ + "_/_/_/root/fonts/icons-lib/2PLF60M.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/icons-lib/icons-lib.ttf?n7cb91
// module id = 400
// module chunks = 4